import { Reducer, combineReducers } from "redux";
import { chatsSlice } from "../modules/chat/store/chatSlice";
import { AlertReducer } from "./alert/reducer";
import { buildingReducer } from "./buildings/reducer";
import { cycleReducer } from "./cycle/reducer";
import { EffectsReducer } from "./effects/reducer";
import { audioPlayableReducer } from "./music/reducer";
import { barracksSlice } from "./pages/barracks/barracksSlice";
import { QuestReducer } from "./quests/reducer";
import { ratesReducer } from "./rates/reducer";
import { scoutReducer } from "./scout/reducer";
import { userSettingsReducer } from "./settings/reducer";
import { TourReducer } from "./tour/reducer";
import { userInfoReducer, userTokenReducer } from "./user/reducer";
import { arenaDialogReducer } from "./arena-dialog/reducer";
import announcementsReducer from "./announcements/reducer"; 
import eventReducer from "./events/reducer";
import mapModeReducer from "./mapMode/reducer";

export const rootReducer = combineReducers({
  userToken: userTokenReducer as Reducer,
  userInfo: userInfoReducer as Reducer,
  alert: AlertReducer as Reducer,
  userSettings: userSettingsReducer as Reducer,
  audioPlayable: audioPlayableReducer as Reducer,
  tour: TourReducer as Reducer,
  buildings: buildingReducer as Reducer,
  myScouts: scoutReducer as Reducer,
  currentCycle: cycleReducer as Reducer,
  quests: QuestReducer as Reducer,
  effects: EffectsReducer as Reducer,
  rates: ratesReducer as Reducer,
  barracks: barracksSlice.reducer,
  arenaDialog: arenaDialogReducer as Reducer,
  announcements: announcementsReducer as Reducer,
  chats: chatsSlice.reducer,
  events: eventReducer as Reducer,
  mapMode: mapModeReducer as Reducer,
});

